import React, { Fragment } from "react";
import { useEffect } from "react";

import { useConfig } from "../../core/config";
import { useAnalytics } from "../../lib/analytics/analytics";
import { makeGTMClient } from "../../lib/analytics/gtm";
import { makePixelClient } from "../../lib/analytics/pixel";
import { makeLinkedInClient } from "../../lib/analytics/linkedin";
import { makeGA4Client } from "../../lib/analytics/ga4";

export function useRoomsAnalytics() {
  const config = useConfig();
  const analytics = useAnalytics();

  useEffect(() => {
    const variables = envVariables[config.environment];

    // Facebook Pixel
    if (variables.fbPixelId) {
      const pixelClient = makePixelClient(variables.fbPixelId);

      analytics.addClient(pixelClient);
    }

    // LinkedIn insight tag
    if (variables.linkedInTrackingId) {
      const linkedInClient = makeLinkedInClient(variables.linkedInTrackingId);

      analytics.addClient(linkedInClient);
    }

    // Google tag manager
    if (variables.ga4TrackingId) {
      const ga4Client = makeGA4Client({
        trackingId: variables.ga4TrackingId,
        gaOptions: {
          name: "rooms",
        },
      });

      analytics.addClient(ga4Client);
    }

    if (variables.gtmId) {
      const gtmClient = makeGTMClient(variables.gtmId);

      analytics.addClient(gtmClient);
    }
  }, [config.environment, analytics]);
}

const envVariables = {
  development: {
    fbPixelId: "1070255396991528",
    linkedInTrackingId: "",
    ga4TrackingId: "",
    adsId: "",
    adsSlot: "",
    gtmId: "",
  },
  staging: {
    fbPixelId: "1070255396991528",
    linkedInTrackingId: "",
    ga4TrackingId: "G-W1BYT19L2G",
    adsId: "",
    adsSlot: "",
    gtmId: "GTM-T44X6MH",
  },
  production: {
    fbPixelId: "1283413158484803",
    linkedInTrackingId: "4978865",
    ga4TrackingId: "G-3EBZ4ZJZYN",
    adsId: "AW-721142016",
    adsSlot: "",
    gtmId: "GTM-KQFHB6X",
  },
};

export default function RoomsAnalytics(): JSX.Element {
  useRoomsAnalytics();

  return <Fragment></Fragment>;
}
